var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGridTable = function SvgGridTable(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1,
    d: "M1.5 6.5h15m-10-5v15m-5-5h15m-15-4.667v4.334c0 1.867 0 2.8.363 3.513.32.627.83 1.137 1.457 1.457.713.363 1.646.363 3.513.363h4.334c1.867 0 2.8 0 3.513-.363a3.334 3.334 0 0 0 1.457-1.457c.363-.713.363-1.646.363-3.513V6.833c0-1.867 0-2.8-.363-3.513a3.333 3.333 0 0 0-1.457-1.457c-.713-.363-1.646-.363-3.513-.363H6.833c-1.867 0-2.8 0-3.513.363-.627.32-1.137.83-1.457 1.457C1.5 4.033 1.5 4.966 1.5 6.833Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGridTable);
export default ForwardRef;